import { useEffect, useMemo } from 'react';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom'; // Added useSearchParams
import SignupForm from 'components/auth/signup/form'; // Assuming SignupForm can handle both flows or we adapt it
import AuthMainLayout from 'layouts/auth-main';
import {
  useGetSingleOwnerAsGuestQuery, useRegisterWithPropertyMutation
} from 'redux/api/ciosUsersApi/ciosUsersApi';
import LoadingPageLayout from 'common/layouts/loading-page';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { setCredentials, logout } from 'redux/features/auth/authSlice';
import { clearClaimsDraft } from 'redux/features/claims/claimsSlice';
import { clearPlansDraft } from 'redux/features/plans/plansSlice';
import { createPropertyOptionMenu, propertyFilterOption } from 'common/components/dropdowns';
import SignupInfo from 'components/auth/signup/signup-info';
import { backgroundTypeEnum } from 'common/utils/enums';

const SignupWithOwner = () => {
  const { ownerID } = useParams();
  const [searchParams] = useSearchParams(); // To get leaseCategory if passed in URL
  const dispatch = useDispatch();
  const navigate = useNavigate();  

  const {
    data: ownerQuery,
    isLoading,
    isError,
    error,
  } = useGetSingleOwnerAsGuestQuery(ownerID, {
    skip: !ownerID,
  });

  const ownerData = ownerQuery?.owner || {};
  const propertiesData = ownerQuery?.properties || [];

  const propertyOptions = useMemo(() => createPropertyOptionMenu(propertiesData), [propertiesData]);

  useEffect(() => {
    console.log('Owner Data:', ownerData);
    console.log('Properties Data:', propertiesData);
  }, [ownerData, propertiesData]);

  const [
    registerWithProperty,
    { isLoading: isRegisteringWithProperty, isSuccess: isRegisterSuccess },
  ] = useRegisterWithPropertyMutation();

  useEffect(() => {
    dispatch(logout());
    dispatch(clearClaimsDraft());
    dispatch(clearPlansDraft());
  }, [dispatch]);

  const handleSignupWithOwner = async (values) => {
    // 'values' will come from the SignupForm
    try {
      // const leaseCategory =
      //   searchParams.get('category') || leaseCategoryEnum.NEW; // Get category from URL or default

      const { data } = await registerWithProperty({
        ...values, // firstName, lastName, email, phone, password, property
      }).unwrap();

      toast.info(
        data?.message ||
          'Registration successful! Please check your email to complete your plan.'
      );
      dispatch(
        setCredentials({
          isLoggedIn: true, // Or false if email confirmation is strictly required before setting as logged in
          token: data?.token,
          user: data?.user,
        })
      );
      // The backend now sends an email with /attach-plan link.
      // The user will click this link to continue.
      // We can navigate to a generic "check your email" page or the confirm-email page
      // as a fallback or if immediate navigation is desired before email interaction.
      navigate(`/confirm-email?propertyID=${values?.propertyID}`); // Or a custom "Check your email to continue" page
    } catch (err) {
      toast.error(err?.data?.msg || 'Registration failed.');
      console.error('Registration with property failed:', err);
    }
  };

  return (
    <AuthMainLayout 
      asideChild={<SignupInfo />}
      backgroundType={isLoading ? backgroundTypeEnum.BACKGROUND_DARK : ownerData?.brand?.backgroundType}
      bgColor={isLoading ? '#191923' : ownerData?.brand?.bgColor}
      logo={isLoading ? null : ownerData?.brand?.logo}
    >
      {/*
        Pass the new onSubmit handler to SignupForm.
        SignupForm's internal onSubmit needs to be adapted or it needs a new prop.
        Let's assume SignupForm can take an =externalOnSubmit= prop.
      */}
      <SignupForm
        owner={ownerData}
        propertyOptions={propertyOptions}
        filterOption={propertyFilterOption}
        externalOnSubmit={handleSignupWithOwner} // Pass the new handler
        isLoading={isRegisteringWithProperty} // Pass loading state
      />
    </AuthMainLayout>
  );
};
export default SignupWithOwner;
